import { put, takeLatest, call } from "redux-saga/effects";
import CatalogoActions, {
  Types as CatalogoTypes,
} from "../../stores/catalogo/Actions";
import CatalogoService from "../../services/catalogo/CatalogoService";
import { removeLineBreaks } from "../../utils/StringUtil";
import ResponseCode from "../../services/ResponseCode";

function* getZonas(request) {
  yield put(CatalogoActions.getZonasLoading());

  const zonasResponse = yield call(CatalogoService.getZonas, request.payload);

  const zonas = zonasResponse?.distribucionPolitica?.map((zona) => {
    return {
      id: zona.codigoDistribucion,
      key: zona.codigoDistribucion,
      label: zona.distribucionPolitica,
      value: zona.distribucionPoliticaId,
    };
  });

  yield put(CatalogoActions.getZonasSuccess({ zonas }));
}

function* getProvincias(request) {
  yield put(CatalogoActions.getProvinciasLoading());

  const provinciasResponse = yield call(
    CatalogoService.getProvincias,
    request.payload
  );

  const provincias = provinciasResponse?.distribucionPolitica?.map(
    (provincia) => {
      return {
        id: provincia.distribucionPoliticaId,
        key: provincia.codigoDistribucion,
        label: provincia.distribucionPolitica,
        value: provincia.codigoDistribucion,
      };
    }
  );

  yield put(CatalogoActions.getProvinciasSuccess({ provincias }));
}

function* getDiagnosticos() {
  yield put(CatalogoActions.getDiagnosticosLoading());

  const diagnosticosResponse = yield call(CatalogoService.getDiagnosticos);

  const diagnosticos = diagnosticosResponse?.listadoDiagnosticos?.map(
    (diagnostico) => {
      return {
        ...diagnostico,
        key: diagnostico.codigo,
        descripcion: removeLineBreaks(
          diagnostico.descripcion || "Sin descripción"
        ),
      };
    }
  );

  yield put(CatalogoActions.getDiagnosticosSuccess({ diagnosticos }));
}

function* getGrupos() {
  yield put(CatalogoActions.getGruposLoading());

  try {
    const gruposResponse = yield call(CatalogoService.getGrupos);

    if (
      !gruposResponse?.respuesta ||
      gruposResponse?.respuesta?.codigo === ResponseCode.SERVER_ERROR.code
    ) {
      yield put(
        CatalogoActions.getGruposFailure({
          codigo: ResponseCode.SERVER_ERROR.code,
          mensaje: ResponseCode.SERVER_ERROR.message,
        })
      );
      return;
    }

    if (gruposResponse?.respuesta?.codigo !== ResponseCode.OK.code) {
      yield put(CatalogoActions.getGruposFailure(gruposResponse?.respuesta));
      return;
    }

    const grupos =
      gruposResponse?.data?.grupos?.map((grupo) => {
        return {
          value: grupo.nombre,
          label: grupo.nombre,
          id: grupo.id,
          key: grupo.id,
        };
      }) || [];

    yield put(CatalogoActions.getGruposSuccess(grupos));
  } catch (error) {
    yield put(
      CatalogoActions.getGruposFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: "Error al obtener grupos: " + error.message,
      })
    );
  }
}

function* getDepartamentos() {
  yield put(CatalogoActions.getDepartamentosLoading());

  try {
    const departamentosResponse = yield call(CatalogoService.getDepartamentos);

    if (
      !departamentosResponse?.respuesta ||
      departamentosResponse?.respuesta?.codigo ===
        ResponseCode.SERVER_ERROR.code
    ) {
      yield put(
        CatalogoActions.getDepartamentosFailure({
          codigo: ResponseCode.SERVER_ERROR.code,
          mensaje: ResponseCode.SERVER_ERROR.message,
        })
      );
      return;
    }

    if (departamentosResponse?.respuesta?.codigo !== ResponseCode.OK.code) {
      yield put(
        CatalogoActions.getDepartamentosFailure(
          departamentosResponse?.respuesta
        )
      );
      return;
    }

    const departamentos =
      departamentosResponse?.data?.departamentos?.map((departamento) => {
        return {
          value: departamento.nombre,
          label: departamento.nombre,
          id: departamento.id,
          key: departamento.id,
        };
      }) || [];

    yield put(CatalogoActions.getDepartamentosSuccess(departamentos));
  } catch (error) {
    yield put(
      CatalogoActions.getDepartamentosFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: "Error al obtener departamentos: " + error.message,
      })
    );
  }
}

const exportedArray = [
  takeLatest(CatalogoTypes.GET_ZONAS, getZonas),
  takeLatest(CatalogoTypes.GET_PROVINCIAS, getProvincias),
  takeLatest(CatalogoTypes.GET_DIAGNOSTICOS, getDiagnosticos),
  takeLatest(CatalogoTypes.GET_GRUPOS, getGrupos),
  takeLatest(CatalogoTypes.GET_DEPARTAMENTOS, getDepartamentos),
];

export default exportedArray;
